<template>
  <div class="container editZone">
    <h1 class="title">
      <span class="icon clickable returnIcon" @click="goBack">
        <i class="mdi mdi-chevron-left"></i>
      </span>
      {{ zone.name }}
    </h1>

    <h2 class="subtitle">{{ title }}</h2>

    <div class="columns">
      <div class="column">
        <b-field :label="$t('zone.name')">
          <b-input v-model="form.name"></b-input>
        </b-field>
        <div v-if="showFinalSelect" class="field">
          <b-switch v-model="form.final" type="is-success">
            {{ $t("zone.isFinalZone") }}
          </b-switch>
        </div>
      </div>
      <div class="column">
        <b-field :label="$t('zone.surface')">
          <b-input
            step="0.01"
            v-model.number="form.meters"
            type="number"
          ></b-input>
        </b-field>
        <b-field v-if="form.final" :label="$t('zone.labelType')">
          <b-select :placeholder="$t('zone.selectType')" v-model="form.type">
            <option :value="constants.zoneTypes.acs">
              {{ $t("zone.acs") }}
            </option>
            <option :value="constants.zoneTypes.radiator">
              {{ $t("zone.heat") }}
            </option>
          </b-select>
        </b-field>
      </div>
    </div>
    <br /><br />
    <button
      class="button is-success"
      :disabled="!isFormValid"
      @click="saveZone"
    >
      {{ $t("buttons.save") }}
    </button>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import constants from "@/config/constants";
import i18n from "@/config/i18n";

export default {
  name: "zone-wizard",

  data() {
    return {
      type: null,
      form: {
        name: "",
        meters: "",
        final: false,
        type: constants.zoneTypes.acs,
      },

      constants: constants,
    };
  },
  computed: {
    isFormValid: function () {
      return this.form.name.length > 0 && parseFloat(this.form.meters) > 0;
    },

    showFinalSelect: function () {
      switch (this.type) {
        case "AddZone":
          return !this.itemHasChildren(this.installation);
        case "AddSubZone":
          return !this.itemHasChildren(this.zone);
        case "EditZone":
          return false;
      }
    },

    ...mapState("installations", {
      installation: "current",
      installations: "list",
    }),

    ...mapState("zones", {
      zone: "current",
    }),

    title: function () {
      switch (this.type) {
        case "AddZone":
          return i18n.t("installation.addZone") + " " + this.installation.name;
        case "AddSubZone":
          return i18n.t("zone.addSubZone") + " " + this.zone.name;
        case "EditZone":
          return i18n.t("zone.editZone") + " " + this.zone.name;
      }
    },
  },
  methods: {
    goBack: function () {
      switch (this.type) {
        case "AddZone":
          this.$router.push("/installations/" + this.installation[".key"]);

          break;
        case "AddSubZone":
          this.$router.push(
            "/installations/" +
              this.installation[".key"] +
              "/zone/" +
              this.zone.path.split("/")[this.zone.path.split("/").length - 1]
          );

          break;
        case "EditZone":
          this.$router.push(
            "/installations/" +
              this.installation[".key"] +
              "/zone/" +
              this.zone.path.split("/")[this.zone.path.split("/").length - 1]
          );
          break;
      }
    },

    ...mapActions("installations", {
      setInstallation: "setCurrent",
    }),

    ...mapActions("zones", {
      setZone: "setCurrent",
      addZone: "addZone",
      addSubZone: "addSubZone",
      updateZone: "updateZone",
    }),

    itemHasChildren: function (item) {
      return item.zones !== undefined && Object.keys(item.zones).length > 0;
    },

    loadForm: function () {
      switch (this.type) {
        case "AddZone":
          if (this.itemHasChildren(this.installation))
            this.form.final = Object.values(this.installation.zones)[0].final;

          break;
        case "AddSubZone":
          if (this.itemHasChildren(this.zone))
            this.form.final = Object.values(this.zone.zones)[0].final;
          break;

        case "EditZone":
          this.form.name = this.zone.name;
          this.form.meters = this.zone.meters;
          break;
      }
    },

    saveZone: function () {
      switch (this.type) {
        case "AddZone":
          this.addZone(this.form).then(() => {
            this.$router.push("/installations/" + this.installation[".key"]);
          });
          break;
        case "AddSubZone":
          this.addSubZone({ parent: this.zone, form: this.form }).then(() => {
            this.$router.push(
              "/installations/" +
                this.installation[".key"] +
                "/zone/" +
                this.zone.path.split("/")[this.zone.path.split("/").length - 1]
            );
          });
          break;
        case "EditZone":
          this.updateZone({ zone: this.zone, form: this.form }).then(() => {
            this.$router.push(
              "/installations/" +
                this.installation[".key"] +
                "/zone/" +
                this.zone.path.split("/")[this.zone.path.split("/").length - 1]
            );
          });
          break;
      }
    },
  },
  created() {
    this.type = this.$router.currentRoute.name;
  },

  mounted() {
    this.setInstallation(this.$route.params.id)
      .then(() => {
        if (this.$route.params.idZone)
          this.setZone(this.$route.params.idZone).then(() => {
            this.loadForm();
          });
        else this.loadForm();
      })
      .catch(() => {
        this.$router.push("/installations");
      });
  },
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 100%;
}

.editZone {
  padding: 0 2rem 2rem;
}

h1.title {
  margin: 3rem 0 5rem;
}
</style>
